import { CropConnectRoleDefinitions } from '../../cropConnectApiClient';

/**  CropConnectRoleDefinitions.Grower_DE,
 CropConnectRoleDefinitions.Grower_Beet_DE,
 CropConnectRoleDefinitions.Grower_Organic_DE,
 CropConnectRoleDefinitions.Grower_Beet_Organic_DE,
 CropConnectRoleDefinitions.Grower_PL,
 CropConnectRoleDefinitions.Grower_Beet_PL,
 CropConnectRoleDefinitions.Grower_Organic_PL,
 CropConnectRoleDefinitions.Grower_Beet_Organic_PL,
 CropConnectRoleDefinitions.Grower_SK,
 CropConnectRoleDefinitions.Grower_Beet_SK,
 CropConnectRoleDefinitions.Grower_Organic_SK,
 CropConnectRoleDefinitions.Grower_Beet_Organic_SK,
 CropConnectRoleDefinitions.Grower_FI,
 CropConnectRoleDefinitions.Grower_Beet_FI,
 CropConnectRoleDefinitions.Grower_Organic_FI,
 CropConnectRoleDefinitions.Grower_Beet_Organic_FI,*/
export const contractFullfilmentReportRequiredRoleDefinitions = [
  CropConnectRoleDefinitions.Grower_DE,
  CropConnectRoleDefinitions.Grower_Beet_DE,
  CropConnectRoleDefinitions.Grower_Organic_DE,
  CropConnectRoleDefinitions.Grower_Beet_Organic_DE,
  CropConnectRoleDefinitions.Grower_PL,
  CropConnectRoleDefinitions.Grower_Beet_PL,
  CropConnectRoleDefinitions.Grower_Organic_PL,
  CropConnectRoleDefinitions.Grower_Beet_Organic_PL,
  CropConnectRoleDefinitions.Grower_SK,
  CropConnectRoleDefinitions.Grower_Beet_SK,
  CropConnectRoleDefinitions.Grower_Organic_SK,
  CropConnectRoleDefinitions.Grower_Beet_Organic_SK,
  CropConnectRoleDefinitions.Grower_FI,
  CropConnectRoleDefinitions.Grower_Beet_FI,
  CropConnectRoleDefinitions.Grower_Organic_FI,
  CropConnectRoleDefinitions.Grower_Beet_Organic_FI,
];

/**CropConnectRoleDefinitions.Grower_DE,
 CropConnectRoleDefinitions.Grower_Beet_DE,
 CropConnectRoleDefinitions.Grower_Organic_DE,
 CropConnectRoleDefinitions.Grower_Beet_Organic_DE,
 CropConnectRoleDefinitions.Grower_PL,
 CropConnectRoleDefinitions.Grower_Beet_PL,
 CropConnectRoleDefinitions.Grower_Organic_PL,
 CropConnectRoleDefinitions.Grower_Beet_Organic_PL,
 CropConnectRoleDefinitions.Grower_SK,
 CropConnectRoleDefinitions.Grower_Beet_SK,
 CropConnectRoleDefinitions.Grower_Organic_SK,
 CropConnectRoleDefinitions.Grower_Beet_Organic_SK,
 CropConnectRoleDefinitions.Grower_FI,
 CropConnectRoleDefinitions.Grower_Beet_FI,
 CropConnectRoleDefinitions.Grower_Organic_FI,
 CropConnectRoleDefinitions.Grower_Beet_Organic_FI,
 CropConnectRoleDefinitions.Grower_DK,
 CropConnectRoleDefinitions.Grower_Beet_DK,
 CropConnectRoleDefinitions.Grower_Organic_DK,
 CropConnectRoleDefinitions.Grower_Beet_Organic_DK,
 CropConnectRoleDefinitions.Grower_SE,
 CropConnectRoleDefinitions.Grower_Beet_SE,
 CropConnectRoleDefinitions.Grower_Organic_SE,
 CropConnectRoleDefinitions.Grower_Beet_Organic_SE, */
export const contractsReportRequiredRoleDefinitions = [
  CropConnectRoleDefinitions.Grower_DE,
  CropConnectRoleDefinitions.Grower_Beet_DE,
  CropConnectRoleDefinitions.Grower_Organic_DE,
  CropConnectRoleDefinitions.Grower_Beet_Organic_DE,
  CropConnectRoleDefinitions.Grower_PL,
  CropConnectRoleDefinitions.Grower_Beet_PL,
  CropConnectRoleDefinitions.Grower_Organic_PL,
  CropConnectRoleDefinitions.Grower_Beet_Organic_PL,
  CropConnectRoleDefinitions.Grower_SK,
  CropConnectRoleDefinitions.Grower_Beet_SK,
  CropConnectRoleDefinitions.Grower_Organic_SK,
  CropConnectRoleDefinitions.Grower_Beet_Organic_SK,
  CropConnectRoleDefinitions.Grower_FI,
  CropConnectRoleDefinitions.Grower_Beet_FI,
  CropConnectRoleDefinitions.Grower_Organic_FI,
  CropConnectRoleDefinitions.Grower_Beet_Organic_FI,
  CropConnectRoleDefinitions.Grower_DK,
  CropConnectRoleDefinitions.Grower_Beet_DK,
  CropConnectRoleDefinitions.Grower_Organic_DK,
  CropConnectRoleDefinitions.Grower_Beet_Organic_DK,
  CropConnectRoleDefinitions.Grower_SE,
  CropConnectRoleDefinitions.Grower_Beet_SE,
  CropConnectRoleDefinitions.Grower_Organic_SE,
  CropConnectRoleDefinitions.Grower_Beet_Organic_SE,
  CropConnectRoleDefinitions.Grower_LT,
  CropConnectRoleDefinitions.Grower_Beet_LT,
  CropConnectRoleDefinitions.Grower_Organic_LT,
  CropConnectRoleDefinitions.Grower_Beet_Organic_LT,
];

/** CropConnectRoleDefinitions.Grower_DE,
 CropConnectRoleDefinitions.Grower_Beet_DE,
 CropConnectRoleDefinitions.Grower_Organic_DE,
 CropConnectRoleDefinitions.Grower_Beet_Organic_DE,
 CropConnectRoleDefinitions.Grower_SK,
 CropConnectRoleDefinitions.Grower_Beet_SK,
 CropConnectRoleDefinitions.Grower_Organic_SK,
 CropConnectRoleDefinitions.Grower_Beet_Organic_SK,
 CropConnectRoleDefinitions.Grower_PL,
 CropConnectRoleDefinitions.Grower_Beet_PL,
 CropConnectRoleDefinitions.Grower_Organic_PL,
 CropConnectRoleDefinitions.Grower_Beet_Organic_PL,
 CropConnectRoleDefinitions.Grower_DK,
 CropConnectRoleDefinitions.Grower_Beet_DK,
 CropConnectRoleDefinitions.Grower_Organic_DK,
 CropConnectRoleDefinitions.Grower_Beet_Organic_DK,
 CropConnectRoleDefinitions.Grower_SE,
 CropConnectRoleDefinitions.Grower_Beet_SE,
 CropConnectRoleDefinitions.Grower_Organic_SE,
 CropConnectRoleDefinitions.Grower_Beet_Organic_SE,
 CropConnectRoleDefinitions.Grower_FI,
 CropConnectRoleDefinitions.Grower_Beet_FI,
 CropConnectRoleDefinitions.Grower_Organic_FI,
 CropConnectRoleDefinitions.Grower_Beet_Organic_FI, */
export const myFieldsAndYieldsRequiredRoleDefinitions = [
  CropConnectRoleDefinitions.Grower_DE,
  CropConnectRoleDefinitions.Grower_Beet_DE,
  CropConnectRoleDefinitions.Grower_Organic_DE,
  CropConnectRoleDefinitions.Grower_Beet_Organic_DE,
  CropConnectRoleDefinitions.Grower_SK,
  CropConnectRoleDefinitions.Grower_Beet_SK,
  CropConnectRoleDefinitions.Grower_Organic_SK,
  CropConnectRoleDefinitions.Grower_Beet_Organic_SK,
  CropConnectRoleDefinitions.Grower_PL,
  CropConnectRoleDefinitions.Grower_Beet_PL,
  CropConnectRoleDefinitions.Grower_Organic_PL,
  CropConnectRoleDefinitions.Grower_Beet_Organic_PL,
  //Enabled as per CCM-1146
  // CropConnectRoleDefinitions.Grower_DK,
  // CropConnectRoleDefinitions.Grower_Beet_DK,
  // CropConnectRoleDefinitions.Grower_Organic_DK,
  // CropConnectRoleDefinitions.Grower_Beet_Organic_DK,
  // CropConnectRoleDefinitions.Grower_SE,
  // CropConnectRoleDefinitions.Grower_Beet_SE,
  // CropConnectRoleDefinitions.Grower_Organic_SE,
  // CropConnectRoleDefinitions.Grower_Beet_Organic_SE,
  // CropConnectRoleDefinitions.Grower_FI,
  // CropConnectRoleDefinitions.Grower_Beet_FI,
  // CropConnectRoleDefinitions.Grower_Organic_FI,
  // CropConnectRoleDefinitions.Grower_Beet_Organic_FI,
  // CropConnectRoleDefinitions.Grower_LT,
  // CropConnectRoleDefinitions.Grower_Beet_LT,
  // CropConnectRoleDefinitions.Grower_Organic_LT,
  // CropConnectRoleDefinitions.Grower_Beet_Organic_LT,
];
